import {
  StaffConversationsResponseSchema,
  type StaffConversationsResponse,
} from '@zrsystem/contracts';

import { getHttpClient } from '@/shared/api/http-client.js';

export async function listStaffConversations(query?: {
  cursor?: string;
  limit?: number;
}): Promise<StaffConversationsResponse> {
  const params = new URLSearchParams();
  if (query?.cursor) {
    params.set('cursor', query.cursor);
  }
  if (query?.limit) {
    params.set('limit', String(query.limit));
  }
  const suffix = params.size > 0 ? `?${params.toString()}` : '';
  const raw = await getHttpClient().get<unknown>(`/api/conversations${suffix}`);
  return StaffConversationsResponseSchema.parse(raw);
}
